import { render, staticRenderFns } from "./TextDoi.vue?vue&type=template&id=77aea4c8&"
import script from "./TextDoi.vue?vue&type=script&lang=js&"
export * from "./TextDoi.vue?vue&type=script&lang=js&"
import style0 from "./TextDoi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports